import { useRecordContext } from "react-admin";

//only show Bank Name
const BankNameField = (props) => {
  const record = useRecordContext();
  return <>{record ? record.sBankName : ""}</>;
};
export default BankNameField;
